import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function ProtectedRoute({ children, adminOnly = false, allowGuests = false }) {
  const { user, isGuest, loading } = useAuth();

  if (loading) {
    return null;
  }

  if (!user && !isGuest) {
    return <Navigate to="/login" replace />;
  }

  if (isGuest && !allowGuests) {
    return <Navigate to="/login" replace />;
  }

  if (adminOnly && (!user || user.is_admin !== true)) {
    return <Navigate to="/" replace />;
  }

  return children;
}

export default ProtectedRoute;
